import {
  InAppNotificationLogType
} from '@generated/graphql';
import {ModelFactory} from "@shared/factories/model.factory";
import {InAppNotificationLog} from "@modules/in-app-notification-log/models/in-app-notification-log.model";

export class InAppNotificationLogModelFactory extends ModelFactory<InAppNotificationLogType, InAppNotificationLog> {
  create(state): InAppNotificationLog {
    return new InAppNotificationLog(state);
  }
}

export const inAppNotificationLogModelFactory = new InAppNotificationLogModelFactory();
